import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStore from '../../../withStore';

import SEOLinks from './SEOLinks';

const SEOLinksContainer = ({
  clearCoordinates,
  utmParams,
}) => {
  const handleClick = () => {
    clearCoordinates();
  };

  return (
    <SEOLinks onClick={handleClick} utmParams={utmParams} />
  );
};

SEOLinksContainer.propTypes = {
  clearCoordinates: PropTypes.func.isRequired,
  utmParams: PropTypes.object.isRequired,
};

const mapDispatch = ({ search }) => ({
  clearCoordinates: search.clearCoordinates,
});

export default withStore(connect(null, mapDispatch)(SEOLinksContainer));
